import React, { useState } from "react";

import Loader from "react-loader-spinner";
import { Modal } from "react-bootstrap";
import { useTranslation } from 'react-i18next';


import { eventsRequests, searchRequests } from "../../Utils/Api";

import eye from "../../img/for_table/eye.svg";
import like from "../../img/for_table/like.svg";
import coment from "../../img/for_table/coment.svg";
import money from "../../img/for_table/money.svg";
import history from "../../img/for_table/history.svg";
import search from "../../img/for_table/search.svg";

import PointsHistory from "../../elements/PointsHistory";

import ReactNotification from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import { store } from "react-notifications-component";

import NoActive from "../Main/NoActive";

const Table = props => {
  const [topSubscribers, getTopSubscribers] = useState([]);
  const [searchInputValue, setSearchInputValue] = useState("");
  const [searchResoult, getResoult] = useState([]);
  const [searchResoults, showSearchResoults] = useState(false);
  const [showSubscriberHistory, setShowHistory] = useState(false);
  const [selectedSubscribers, selectSubscribers] = useState("");
  const [findedSubscriber, getFindedSubscriber] = useState(null);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation("table");

  useState(() => {
    eventsRequests
      .getTopSubscribers(props.bloggerData.id)
      .then(data => {
        getTopSubscribers(data.data);
        setLoading(false);
      })
      .catch(err => console.log(err));
  });

  const handleSearch = e => {
    setSearchInputValue(e.target.value);
    if (e.target.value === "") {
      showSearchResoults(false);
      getResoult([]);
    } else {
      searchRequests
        .findSubscribers(props.bloggerData.id, e.target.value)
        .then(data => {
          getResoult(data.data);
          if (data.data.length !== 0) {
            showSearchResoults(true);
          } else {
            showSearchResoults(false);
          }
        })
        .catch(err => console.log(err));
    }
  };

  const selectSubscriber = e => {
    showSearchResoults(false);
    setSearchInputValue("");

    searchRequests
      .findSubscriberByName(props.bloggerData.id, searchResoult[e])
      .then(data => getFindedSubscriber(data.data))
      .catch(err => console.log(err));
  };

  const showHistory = index => {
    selectSubscribers(topSubscribers[index]);
    setShowHistory(true);
  };

  const showHistoryOfFindedSubscriber = data => {
    selectSubscribers(data);
    setShowHistory(true);
  };

  const clickButtonSearch = () => {
    if (searchInputValue === "") {
      showSearchResoults(false);
      getResoult([]);
    } else {
      searchRequests
        .findSubscriberByName(props.bloggerData.id, searchInputValue)
        .then(data => {
          if (data.data.length !== 0) {
            getFindedSubscriber(data.data);
            showSearchResoults(false);
          } else {
            showSearchResoults(false);

            store.addNotification({
              title: "",
              message: t('Такого участника не существует'),
              type: "danger",
              insert: "top",
              container: "bottom-left",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 3000
              },
              width: 300
            });
          }
        })
        .catch(err => console.log(err));
    }
  };

  if (!loading) {
    if (topSubscribers.length !== 0) {
      return (
        <div className="table_container">
          <ReactNotification />
          <Modal
            show={showSubscriberHistory}
            onHide={() => setShowHistory(false)}
            centered
          >
            <PointsHistory
              bloggerId={props.bloggerData.id}
              subscriber={selectedSubscribers}
              close={setShowHistory}
            />
          </Modal>
          <div className="search_container">
            <div className="search_input">
              <input
                type="text"
                placeholder={ t('Найти подписчика') }
                onChange={handleSearch}
                value={searchInputValue}
              />
              <div>
                <img
                  src={search}
                  alt=""
                  onClick={clickButtonSearch}
                  style={{ cursor: "pointer" }}
                />
              </div>
            </div>
            <div className="search_resoults_container">
              {searchResoults ? (
                <div className="search_resoults">
                  <ul>
                    {searchResoult.map((item, index) => {
                      return (
                        <li key={index} onClick={() => selectSubscriber(index)}>
                          {item}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ) : null}
            </div>
          </div>
          <div className="subscribers_table_container">
            <table className="subscribers_table">
              <thead>
                <tr className="subscribers_table_header">
                  <th className="subscribers_table_vertical_border">№</th>
                  <th className="subscribers_table_vertical_border">
                    { t("Подписчик") }
                  </th>
                  <th className="subscribers_table_vertical_border">
                    <img src={like} alt="" />
                  </th>
                  <th className="subscribers_table_vertical_border">
                    <img src={coment} alt="" />
                  </th>
                  <th className="subscribers_table_vertical_border">
                    <img src={money} alt="" />
                  </th>
                  <th className="show_points_button">
                    <img src={history} alt="" style={{ cursor: "default" }} />
                  </th>
                </tr>
              </thead>

              <tbody>
                {findedSubscriber ? (
                  <tr className="find_subscriber">
                    <td
                      className="subscribers_table_vertical_border"
                      style={{ textAlign: "center" }}
                    >
                      -
                    </td>
                    <td className="subscribers_table_vertical_border">
                      {findedSubscriber.name}
                    </td>
                    <td
                      className="subscribers_table_vertical_border"
                      style={{ textAlign: "center" }}
                    >
                      {findedSubscriber.likes}
                    </td>
                    <td
                      className="subscribers_table_vertical_border"
                      style={{ textAlign: "center" }}
                    >
                      {findedSubscriber.comments}
                    </td>
                    <td
                      className="subscribers_table_vertical_border"
                      style={{ textAlign: "center" }}
                    >
                      {findedSubscriber.total}
                    </td>
                    <td
                      className="show_points_button"
                      style={{ textAlign: "center" }}
                    >
                      <img
                        src={eye}
                        alt=""
                        onClick={() =>
                          showHistoryOfFindedSubscriber(findedSubscriber)
                        }
                      />
                    </td>
                  </tr>
                ) : null}

                {topSubscribers.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td
                        className="subscribers_table_vertical_border"
                        style={{ textAlign: "center" }}
                      >
                        {index + 1}
                      </td>
                      <td className="subscribers_table_vertical_border">
                        {item.name}
                      </td>
                      <td
                        className="subscribers_table_vertical_border"
                        style={{ textAlign: "center" }}
                      >
                        {item.likes}
                      </td>
                      <td
                        className="subscribers_table_vertical_border"
                        style={{ textAlign: "center" }}
                      >
                        {item.comments}
                      </td>
                      <td
                        className="subscribers_table_vertical_border"
                        style={{ textAlign: "center" }}
                      >
                        {item.total}
                      </td>
                      <td
                        className="show_points_button"
                        style={{ textAlign: "center" }}
                      >
                        <img
                          src={eye}
                          alt=""
                          onClick={() => showHistory(index)}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      );
    } else {
      return <NoActive bloggerData={props.bloggerData} />;
    }
  } else {
    return (
      <div className="table_loader">
        <Loader
          type="Oval"
          color={window.innerWidth <= 1224 ? "#ffffff" : "#7ac479"}
          height={60}
          width={60}
        />
      </div>
    );
  }
};

export default Table;
